export { default as default } from './Embed';
